<template>
    <div class="my-5">
        <!--        <div class="d-flex justify-content-center tab px-0 gap-2">-->
        <!--            <button v-if="template?.questions.trueOrFalse.questions.length > 0" class="tablinks active" @click="openTap($event , 'trueOrFalse', 'True Or False')">True Or False</button>-->
        <!--            <button v-if="template?.questions.multipleChoices.questions.length > 0" class="tablinks" @click="openTap($event , 'multipleChoices', 'Multiple Choices')">Multiple Choices</button>-->
        <!--            <button v-if="template?.questions.freeText.questions.length > 0" class="tablinks" @click="openTap($event , 'freeText', 'Free Text')">Free Text</button>-->
        <!--            <button v-if="template.questions.slides.category.length > 0" class="tablinks" @click="openTap($event , 'slides', 'Slides')">Slides</button>-->
        <!--        </div>-->


        <div class="d-flex justify-content-center tab px-0 gap-2 tabs-container" style="overflow:unset">
            <button v-if="template?.questions.trueOrFalse.questions.length > 0" class="tablinks tablink1"
                    :class="{active: template?.questions.trueOrFalse.questions.length > 0}"
                    @click="openTap($event , 'trueOrFalse', 'True Or False')">
                    <div class="d-flex justify-content-center">
                        <p class="product-details">{{template.questions['trueOrFalse'].title}}</p>
                        <span class="product-details-full">{{template.questions['trueOrFalse'].title}}</span>
                    </div>
            </button>
            <button v-if="template?.questions.multipleChoices.questions.length > 0" class="tablinks tablink2"
                    :class="{active: template?.questions.trueOrFalse.questions.length === 0}"
                    @click="openTap($event , 'multipleChoices', 'Multiple Choices')">
                    <div class="d-flex justify-content-center">
                        <p class="product-details">{{template.questions['multipleChoices'].title}}</p>
                        <span class="product-details-full">{{template.questions['multipleChoices'].title}}</span>
                    </div>
            </button>
            <button v-if="template?.questions?.freeText?.questions.length > 0" class="tablinks tablink3"
                    :class="{active:
                    (template?.questions.trueOrFalse.questions.length === 0)
                    &&  (template?.questions.multipleChoices.questions.length === 0)
            }"
                    @click="openTap($event , 'freeText', 'Free Text')">
                    <div class="d-flex justify-content-center">
                        <p class="product-details">{{template.questions['freeText'].title}}</p>
                        <span class="product-details-full">{{template.questions['freeText'].title}}</span>
                    </div>
            </button>
            <button v-if="template?.questions.slides.category.length > 0" class="tablinks tablink4"
                    :class="{active:
                    template?.questions.trueOrFalse.questions.length === 0
                    && template?.questions.multipleChoices.questions.length === 0
                    && template?.questions.freeText.questions.length === 0
            }"
                    @click="openTap($event , 'slides', 'Slides')">
                    <div class="d-flex justify-content-center">
                        <p class="product-details">{{template.questions['slides'].title}}</p>
                        <span class="product-details-full">{{template.questions['slides'].title}}</span>
                    </div>
            </button>
            <button v-if="template?.questions.rank.questions.length" class="tablinks tablink5"
                    :class="{active:
                    template?.questions.slides.category.length === 0
                    && template?.questions.trueOrFalse.questions.length === 0
                    && template?.questions.multipleChoices.questions.length === 0
                    && template?.questions.freeText.questions.length === 0
            }"
                    @click="openTap($event , 'rank', 'Rank')">
                    <div class="d-flex justify-content-center">
                        <p class="product-details">{{template.questions['rank'].title}}</p>
                        <span class="product-details-full">{{template.questions['rank'].title}}</span>
                    </div>
            </button>

            <button v-if="template?.questions.arrange.questions.length > 0" class="tablinks tablink6"
                    :class="{active:
                     template?.questions.slides.category.length === 0
                    && template?.questions.trueOrFalse.questions.length === 0
                    && template?.questions.multipleChoices.questions.length === 0
                    && template?.questions.freeText.questions.length === 0
                    && template?.questions.rank.questions.length === 0
            }"
                    @click="openTap($event , 'arrange', 'Arrange')">
                <div class="d-flex justify-content-center">
                    <p class="product-details">{{template.questions['arrange'].title}}</p>
                    <span class="product-details-full">{{template.questions['arrange'].title}}</span>
                </div>
            </button>
        </div>


        <div id="trueOrFalse" ref="trueOrFalse" class="tabcontent"
             :class="{'d-block': template?.questions.trueOrFalse.questions.length > 0}">
            <true-or-false-component v-if="this.template?.questions.trueOrFalse.questions.length > 0"
                                     :template="this.template?.questions.trueOrFalse"/>
        </div>

        <div id="multipleChoices" class="tabcontent tabcontent-border-style"
             :class="{'d-block': ((template?.questions.trueOrFalse.questions.length === 0)
             && (this.template?.questions.multipleChoices.questions.length > 0) )}">
            <multiple-choices-component v-if="this.template?.questions.multipleChoices.questions.length > 0"
                                        :template="this.template?.questions.multipleChoices"/>
        </div>

        <div id="freeText" class="tabcontent tabcontent-border-style"
             :class="{'d-block': ((template?.questions.trueOrFalse.questions.length === 0)
             && (template?.questions.multipleChoices.questions.length === 0)
             && (this.template?.questions.freeText.questions.length > 0))}">
            <free-text-component v-if="this.template?.questions.freeText.questions.length > 0"
                                 :template="this.template?.questions.freeText"/>
        </div>

        <div id="slides" class="tabcontent tabcontent-border-style"
             :class="{'d-block': ((template?.questions.trueOrFalse.questions.length === 0)
             && (template?.questions.multipleChoices.questions.length === 0) && (this.template?.questions.freeText.questions.length === 0)
             && (this.template?.questions.slides.category.length > 0))}">
            <slides-component v-if="this.template?.questions.slides?.category.length > 0"

                              :template="this.template?.questions.slides"/>
        </div>

        <div id="rank" class="tabcontent tabcontent-border-style"
             :class="{'d-block': ((template?.questions.trueOrFalse.questions.length === 0)
             && (template?.questions.multipleChoices.questions.length === 0)
             && (this.template?.questions.freeText.questions.length === 0)
             && (this.template?.questions.slides.category.length === 0)
             && (this.template?.questions.rank.questions.length > 0)

             )}">
            <rank-component v-if="this.template?.questions.rank.questions.length > 0"

                              :template="this.template?.questions.rank"/>
        </div>

        <div id="arrange" class="tabcontent tabcontent-border-style"
             :class="{'d-block': ((template?.questions.trueOrFalse.questions.length === 0)
             && (template?.questions.multipleChoices.questions.length === 0)
             && (this.template?.questions.freeText.questions.length === 0)
             && (this.template?.questions.slides.category.length === 0)
             && (this.template?.questions.rank.questions.length === 0)
             && (this.template?.questions.arrange.questions.length > 0)

             )}">
            <arrange-component v-if="this.template?.questions.arrange.questions.length > 0"

                              :template="this.template?.questions.arrange"/>
        </div>


    </div>

</template>

<script>

    import TrueOrFalseComponent from "./trueOrFalse";
    import MultipleChoicesComponent from "./multipleChoices";
    import FreeTextComponent from "./freeText";
    import SlidesComponent from "./slides";
    import RankComponent from "./rank";
    import ArrangeComponent from "./arrange";

    export default {
        name: 'questions-component',

        components: {SlidesComponent, FreeTextComponent, MultipleChoicesComponent, TrueOrFalseComponent, RankComponent, ArrangeComponent},
        data() {
            return {
                counter: 0,
            }
        },
        async updated() {
            console.log("EGILA ", this.counter, this.template['questions'])
            for (const property in this.template['questions']) {
                console.log(property, this.template['questions'][property])
                if (property !== 'slides') {
                    console.log("A")
                    if (this.template['questions'][property]['questions'].length > 0) {

                        this.counter += 1;
                    }
                } else {
                    console.log("B")
                    if (this.template['questions'][property]['images'].length > 0) {
                        this.counter += 1;
                    }
                }
            }

            if( this.counter === 1){
                console.log('sss..')
                document.getElementsByClassName("tablinks")[0].style.cursor = 'auto';
            }
        },
        props: ['template'],
        methods: {
            openTap(e, tapName, tapTitle) {
                let i, tabcontent, tablinks;

                tabcontent = document.getElementsByClassName("tabcontent");


                this.$emit('weight', this.template.questions[tapName].weight);
                if (tapName !== 'trueOrFalse')
                    e.currentTarget.className += " trueOrFalse";
                for (i = 0; i < tabcontent.length; i++) {
                    // tabcontent[i].style.display = "none";

                    tabcontent[i].className = tabcontent[i].className.replace(" d-block", "");
                    tabcontent[i].className = tabcontent[i].className.replace(" d-none", "");
                    tabcontent[i].className += " d-none";
                }
                tablinks = document.getElementsByClassName("tablinks");
                for (i = 0; i < tablinks.length; i++) {
                    tablinks[i].className = tablinks[i].className.replace(" active", "");
                }
                // document.getElementById(tapName).style.display = "block";
                e.currentTarget.className += " active";
                document.getElementById(tapName).className = document.getElementById(tapName).className.replace("d-none", "d-block");

            },
        }
    }
</script>

<style scoped>
    

    .product-details{
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: 'Lato', sans-serif;
    }

    .product-details:hover + .product-details-full {
        position: absolute;
        top: -45px;
        z-index: 9999;
        color: #e95626;
        background-color: #002634;
        display: flex;
        padding: 10px;
        border-radius: 5px;
        font-family: 'Lato', sans-serif;
    }

    .product-details-full {
        display: none;
    }

    .tabcontent {
        display: none;
        overflow-y: auto;
        height: 55vh;
        border-radius: 10px;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        
    }

    .tablinks {
        width: auto;
        font-weight: normal;
        text-transform: unset;
        position: relative;
        font-size: 15px;
        background-color: var(--btn-pagination-background-color);
        color: var(--btn-pagination-color);
        border: 1px solid var(--border-color-data-table);
        border-radius: 5px 5px 0 0 !important;
        height: 35px;
    }
    .tablink1{
        width:24%;
    }
    .tablink2{
        width:24%;
    }
    .tablink3{
        width:15%;
    }
    .tablink4{
        width:11%;
    }
    .tablink5{
        width:11%;
    }
    .tablink6{
        width:15%;
    }
    @media(max-width:1278px){
        .tabcontent{
            border-radius:0 0 10px 10px ;
        }
    }
    
</style>